module.exports = __webpack_public_path__ + "img/icon-man.fb3481c3.png";